import { render } from "./borrower.vue?vue&type=template&id=cf474b14&scoped=true"
import script from "./borrower.vue?vue&type=script&lang=js"
export * from "./borrower.vue?vue&type=script&lang=js"

import "./borrower.vue?vue&type=style&index=0&id=cf474b14&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf474b14"]])

export default __exports__